module.exports = __webpack_public_path__ + "img/mauritania.e395854.webp";